module.exports = "https://web-assets.ifttt.com/packs/media/service-previews/calendar-icon-18af5b21.png";